import React from 'react';

const SvgStar = (props) => (
  <svg width="1em" height="1em" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.05.5l1.16 2.383 2.79.29-2.074 1.765.565 2.562-2.44-1.292L1.61 7.5l.565-2.562L.1 3.174l2.79-.292z"
    />
  </svg>
);

export default SvgStar;
